// Copyright (c) 2016 Deere & Company

import Report, {getDefaultState} from '../state/report';
import actions from '../../actions-list';

const updateWarrantyExpirationReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_WARRANTY_EXPIRATION_REPORT_SUCCESS]: updateWarrantyExpirationReport,
        [actions.RESET_REPORT_SEARCH_RESULTS]: updateWarrantyExpirationReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/reducers/report.js